import React from 'react'
import InfoContent from 'components/InfoContent'
import section1 from './img/RoroBannerAPP-01.png'
import section2 from './img/RoroBannerAPP-02.png'
import section3 from './img/RoroBannerAPP-03.png'
import section4 from './img/RoroBannerAPP-04.png'
import section5 from './img/RoroBannerAPP-05.png'
import section6 from './img/RoroBannerAPP-06.png'
import { Button } from 'antd'
import routesConfig from 'routesConfig'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { introConfirmed } from 'store/app/actions'
import { connect } from 'react-redux'
import { useLayoutHeader } from 'components/MainLayout'
import './style.css'
import { useState } from 'react'

function IntroView({ history, introConfirmed }) {
    useLayoutHeader({ customClass: 'd-none' })
    const contents = [
        {
            description: <> به اپلیکیشن رورو خوش آمدید.<br /> رورو سامانه حمل و نقل اشتراکی پاک</>,
            img: section1
        },
        {
            description: "روی نقشه نزدیکترین اسکوتر یا دوچرخه رورو را پیدا کنید.\n" +
                "\n",
            img: section2
        },
        {
            description: "کد روی اسکوتر یا دوچرخه را با دوربین موبایل اسکن و قفل آن را باز کنید.\n" +
                "\n",
            img: section3
        },
        {
            description: "با احترام به قوانین شهری و رعایت نکات ایمنی، سفر خود را شروع کنید.\n" +
                "\n",
            img: section4
        },
        {
            description: "اسکوتر یا دوچرخه را در محل مناسب پارک کرده و پایان سفر را در اپلیکیشن انتخاب کنید.\n" +
                "\n",
            img: section5
        },
        {
            description: "معادل زمانی که وسیله نقلیه در اختیار شما بوده است، هزینه سفر خود را پرداخت کنید.\n" +
                "\n",
            img: section6
        },
    ]

    const gotoLogin = () => {
        introConfirmed()
        history.push(routesConfig.login)
    }
    const gotoMap = () => {
        introConfirmed()
        history.push(routesConfig.home)
    }

    const [finished, setFinished] = useState(false)
    return <>
        {!finished && <InfoContent contents={contents} autoplay={false}
            onFinish={() => { setFinished(true) }}
             />}
        {finished && <div style={{ padding: '72px 72px 0' }} className='no-header-sibling'>
            <div className='login-back'>

            </div>
            <p style={{ marginRight: '-32px', marginLeft: '-32px', marginBottom: '32px' }}>

                تازه واردهای عزیز: با عضویت یا ادامه کار در اپلیکیشن رورو
                شما تایید میکنید که
                &nbsp;
                    <a href='https://myroro.ir/terms-and-conditions/' target="_blank">قرارداد کاربری رورو</a>
                    &nbsp;
                    را مطالعه کرده و تمام شرایط آن را پذیرفته اید.
            </p>
            <div style={{ marginRight: '-32px', marginLeft: '-32px' }}><Button type="primary" block
                onClick={gotoLogin}>ثبت‌نام
                         | ورود به حساب کاربری</Button></div>
            <div style={{ marginRight: '-32px', marginLeft: '-32px' }}><Button type="link"
                className='btn-bordered border-green mt-16'
                block
                onClick={gotoMap}>ادامه</Button>
            </div>
        </div>}
    </>
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    introConfirmed,
}, dispatch)

export default connect(null, mapDispatchToProps)(withRouter(IntroView))